// Single source of truth for which roles may access which app pages.
// Consumed by TopNavigation.js (nav link visibility) AND App.js (route
// guards) so the two can't drift apart — they previously did: STAFF had
// Scenario Planning/Inventory/Production Plans hidden from nav while the
// routes themselves were completely unguarded, and Financial Analysis was
// shown in nav with no guard either. Change access here, both places follow.
export const PAGE_ROLES = {
  dashboard: ['SUPER_ADMIN', 'ADMIN'],
  scenarioPlanning: ['SUPER_ADMIN', 'ADMIN', 'STAFF'],
  productDashboard: ['SUPER_ADMIN', 'ADMIN'],
  inventoryManager: ['SUPER_ADMIN', 'ADMIN', 'STAFF'],
  financialAnalysis: ['SUPER_ADMIN', 'ADMIN'],
  productionPlans: ['SUPER_ADMIN', 'ADMIN', 'STAFF'],
};

// Where each role lands immediately after login — SUPER_ADMIN/ADMIN keep the
// Overview landing page; STAFF can't see Overview, so lands on the first
// page their role actually has access to.
export const DEFAULT_LANDING_ROUTE = {
  SUPER_ADMIN: '/dashboard',
  ADMIN: '/dashboard',
  STAFF: '/scenario-planning',
};
